var styles = {"container":"styles_container__2Z-HV mx-auto col-12 md-col-4 mt2 mb2","placement-modal":"styles_placement-modal__22yF_","placementModal":"styles_placement-modal__22yF_"};

export default styles;
//# sourceMappingURL=styles.css.js.map
